<app-loinc-list-display *ngIf="!isDetailView()" [primaryKey]="key" [loincService]="panelsAndFormsService"></app-loinc-list-display>
<div *ngIf="isDetailView()" class="flex justify-center">
    <div class="w-1/5"></div>
    <app-loinc-detail-display class="flex-1" [result]="singleResult" [feedbackURL]="getFeedbackURL()"></app-loinc-detail-display>
    <div class="w-1/5"></div>
</div>
